














































































































































import { VNode } from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { State, Mutation, namespace } from 'vuex-class';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwIconTabDivider } from '@libs-uuif/shared/sw-icon-tab';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import { SwBreadcrumb, BreadcrumbItem } from '@libs-uuif/shared/sw-breadcrumb';
import {
  SwTopNav,
  SwNavStandaloneCollapseTrigger,
  TopNavItem,
} from '@libs-uuif/shared/sw-nav';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwAvatar } from '@libs-uuif/shared/sw-avatar';
import {
  CoreStoreState,
  SetNavCollapsedPayload,
  SetDevicePickerVisiblePayload,
} from '@/core';
import { RootStoreState } from '@/store';
import { navService } from '@/app-shared/nav-service';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { localStorageKeeperService, sessionStorageKeeperService } from '@/shared/auth-service';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { OpenQsgPayload, SwQsgStoreState } from '@/core/sw-qsg';
import { qsgDataStructure } from '@/core/sw-qsg/sw-qsg-data-structure';
import { QsgScreen } from '@/core/sw-qsg/types';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';

const cssPrefix: string = 'sw-app-header';
const qsgNamespace = namespace('SwQsgStoreStateModule');

@Component({
  components: {
    SwIcon,
    SwIconButton,
    SwIconTabDivider,
    SwCountryIcon,
    SwActionBar,
    SwActionBarItem,
    SwBreadcrumb,
    SwDropMenu,
    SwAvatar,
    SwNavStandaloneCollapseTrigger,
    SwTopNav,
    SwBlockingProgress,
  },
  directives: {
    tooltip,
  },
})
export default class SwAppHeader extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @State((state: RootStoreState) => state.CoreStoreModule.navCollapsed)
  readonly navCollapsed: CoreStoreState['navCollapsed'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantName)
  readonly tenantName: CoreStoreState['tenantName'];

  @State(
    (state: RootStoreState) => state.CoreStoreModule.devicePickerSlideVisible,
  )
  readonly devicePickerSlideVisible: CoreStoreState['devicePickerSlideVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.selectedNavItemId)
  readonly selectedNavItemId: CoreStoreState['selectedNavItemId'];

  @Mutation
  setNavCollapsed: VuexMappedMutation<SetNavCollapsedPayload>;

  @Mutation
  setDevicePickerSlideVisible: VuexMappedMutation<
    SetDevicePickerVisiblePayload
  >;

  localeMenuOpened: boolean = false;
  topNavMode: string = 'expand';
  avatarPopoverVisible: boolean = false;
  helpDropdownVisible : boolean = false;
  isLoading = false;
  helpString: string = 'https://www.sonicwall.com/support/technical-documentation/docs/unified_insights-user_guide/Content/introduction.htm/';
  communityUrl : string = 'https://community.sonicwall.com/beta/categories/csc-3-0-unified-insights';

  /**
   * @desc This function sets the configuration for delighted
   */
  private delighted(e:any, t:any, r:string, n:string): void {
    for (let a:any = e[n] = [],
      i = ['survey', 'reset', 'config', 'init', 'set', 'get', 'event', 'identify', 'track', 'page', 'screen', 'group', 'alias'],
      s = 0; s < i.length; s += 1) {
      const c = i[s];
      a[c] = a[c] || function (e) {
        return function () {
          const t = Array.prototype.slice.call(arguments);
          a.push([e, t]);
        };
      }(c);
      a.SNIPPET_VERSION = '1.0.1';
    }
    const o = t.createElement('script');
    o.type = 'text/javascript', o.async = !0, o.src = `https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/${r}/${n}.js`;
    const u = t.getElementsByTagName('script')[0];
    u.parentNode.insertBefore(o, u);
  }

  qsgHeaderStatus: boolean = false;
  @qsgNamespace.Mutation
  readonly openQsg: VuexMappedMutation<OpenQsgPayload>;
  @qsgNamespace.State
  openDropdownLight: SwQsgStoreState['openDropdownLight'];

  @Watch('openDropdownLight')
  openDropdownLightFn(flag: boolean) {
    // console.warn('openDropdownLight Flag', flag);
    // console.warn('openDropdownLight property', this.openDropdownLight);
    this.avatarPopoverVisible = flag;
  }

  @Watch('$route', { immediate: true, deep: true })
  onRouteSwitch(to: any) {  // tslint:disable-line
    if (qsgDataStructure.enable_qsg) {
      const selectedScreen = qsgDataStructure.screens.find((screen: QsgScreen) => {
        return screen.path_name.toLocaleLowerCase() === window.location.pathname.toLocaleLowerCase();
      });
      this.qsgHeaderStatus = selectedScreen !== undefined && selectedScreen.hasOwnProperty('nodes') ? true : false;
    } else {
      this.qsgHeaderStatus = false;
    }
  }

  /**
   * @desc Computed property - returns Navigationbar items
   */
  get topNavItems(): TopNavItem[] {
    const items: TopNavItem[] = [];
    navService.tabNavItems.map((tabItem) => {
      items.push({
        id: tabItem.navId,
        icon: { name: tabItem.icon },
        label: String(this.$t(tabItem.textI18nPath)),
      });
    });
    return items;
  }

  get breadcrumbs(): BreadcrumbItem[] {
    const breadItems = [
      {
        id: 'tenant-selector-icon',
        text: (h: any): VNode => { // tslint:disable-line
          return (
            <div class={['sw-flexbox', 'sw-flexbox--center-items']}>
              <div class={['sw-flexbox', 'sw-flexbox--center-items', `${this.cssPrefix}__breadcrumb-tenant`]}>
                <div class={[`${this.cssPrefix}__breadcrumb-tenant-iocn`]}>
                  <div>
                    <SwIcon name="service-msw" size={16}></SwIcon>
                  </div>
                  <div
                    class={[
                      `${this.cssPrefix}__breadcrumb-tenant-icon-pointer`,
                      'sw-flexbox', 'sw-flexbox--start-items',
                      'sw-flexbox--center-justify',
                    ]}>
                      <SwIcon name="arrow-up" size={8} rotate={180} as-block={true} style={{ marginTop: '2px' }} />
                  </div>
                </div>
                <span  class={[`${this.cssPrefix}__breadcrumb-tenant-name`]}>{this.tenantName}</span>
              </div>
            </div>
          ) as VNode;
        },
        clickable: true,
      },
      { id: 'home', text: 'Home ', clickable: false },
    ];
    if (this.selectedNavItemId === 'dashboard') {
      breadItems.push({ id: 'route', text: 'Dashboard', clickable: false });
    } else if (this.selectedNavItemId === 'reports') {
      breadItems.push({ id: 'route', text: 'Reports', clickable: false });
    }
    return breadItems;
  }

  /**
   * @desc This function handles opening/closing of tenant selector
   */
  private onClickBreadcrumbItem(itemId: string) {
    if (itemId === 'tenant-selector-icon') {
      this.setDevicePickerSlideVisible({
        visible: !this.devicePickerSlideVisible,
      });
    }
  }

  /**
   * @desc This function calls mutation to toggle nav bar collapse boolean
   */
  private onClickCollapseTrigger() {
    this.setNavCollapsed({ collapse: !this.navCollapsed });
  }

    /**
   * @desc This function calls delighted to show feedback-survey modal
   */
  private openDelighted() {
    this.isLoading = true;
    this.delighted(window, document, 'zqCNPWuz2Lg6PrZY', 'delighted');
    try {
      (window as any).delighted.reset();
      const userName = localStorageKeeperService.retrieveJSON('currentUser').displayName || '';
      (window as any).delighted.survey({ name:userName, onShow: () => { this.isLoading = false; } });
    }catch {
      this.isLoading = false;
    }
  }

  /**
   * @desc This function toggles dropdown visibility
   */
  private onClickAvatar() {
    this.avatarPopoverVisible = !this.avatarPopoverVisible;
  }
  /**
   * @desc This function toggles help dropdown visibility
   */
  private onClickHelp() {
    this.helpDropdownVisible = !this.helpDropdownVisible;
  }

  /**
   * @desc Computed property - returns dropdown-menu items
   */
  get avatarMenu(): DropMenuItem[] {
    const menu: DropMenuItem[] = [];
    menu.push({
      id: 'userName',
      content: (h): VNode => { // tslint:disable-line
        return (
          <div class={[[`${cssPrefix}__dropdown-break-word`]]}>
            <span>{this.getUserName()}</span>
          </div>
        ) as VNode;
      },
      clickable: false,
    });
    menu.push({
      id: 'qsg',
      content: (h): VNode => { // tslint:disable-line
        return (
          <div class="sw-qsg-el-open">
            <span>{ this.$t('spog.homepage.qsg')
            .toString() }</span>
          </div>
        ) as VNode;
      },
      clickable: true,
    });
    menu.push({
      id: 'logout',
      content: (h): VNode => { // tslint:disable-line
        return (
          <div class={[[`${cssPrefix}__dropdown-break-word`]]}>
            <span>{ this.$t('pilltooltip.logout')
            .toString() }</span>
          </div>
        ) as VNode;
      },
      clickable: true,
    });
    return menu;
  }

  get helpMenu(): DropMenuItem[] {
    const menu: DropMenuItem[] = [];
    menu.push({
      id: 'community',
      content: (h): VNode => { // tslint:disable-line
        return (
          <div>
            <span>{ this.$t('spog.homepage.joinCommnity')
            .toString() }</span>
          </div>
        ) as VNode;
      },
      clickable: true,
    });
    menu.push({
      id: 'userGuide',
      content: (h): VNode => { // tslint:disable-line
        return (
          <div>
            <span>{ this.$t('spog.homepage.usrGuide')
            .toString() }</span>
          </div>
        ) as VNode;
      },
      clickable: true,
    });
    return menu;
  }

  /**
   * @desc This Function returns current username
   */
  getUserName() {
    const currentUser = JSON.parse(
      localStorageKeeperService.retrieve('currentUser'),
    );
    if (currentUser && currentUser.email) {
      return currentUser.email;
    }
    return 'Unknown User';
  }

  /**
   * @desc This Function Handles drop down action
   * @param {string} itemID - ID of selected dropdown menu
   */
  private onSelectAvatarMenuItem(itemId: string) {
    if (itemId === 'logout') {
      confirmService
        .confirm({
          status: 'informational',
          title: this.$t('pilltooltip.logout')
          .toString(),
          buttons: [
            {
              key: 'cancel',
              name: this.$t('common.cancel')
              .toString(),
            },
            {
              key: 'ok',
              name: this.$t('common.continue')
              .toString(),
              isDefault: true,
            },
          ],
          message: this.$t('logout.cnfrmLogout')
          .toString(),
        })
        .then((key: any) => {
          if (key === 'ok') {
            const currentUserData = JSON.parse(localStorage.getItem('currentUser') || '');
            localStorageKeeperService.clean();
            sessionStorageKeeperService.clean();
            localStorage.setItem('currentUser', JSON.stringify(currentUserData));
            window.location.replace('https://cloud.sonicwall.com/');
          }
        });
    } else if (itemId === 'qsg') {
      this.openQuickStartGuide();
    }
    this.avatarPopoverVisible = false;
  }
  /**
   * @desc This Function Handles drop down action
   * @param {string} itemID - ID of selected dropdown menu
   */
  private onSelectHelpMenuItem(itemId: string) {
    if (itemId === 'community') {
      window.open(this.communityUrl, '_blank');
    } else if (itemId === 'userGuide') {
      window.open(this.helpString, '_blank');
    }
    this.helpDropdownVisible = false;
  }
  private openQuickStartGuide() {
    /*
    const element = document.getElementsByClassName('fw-app-header__avatar')[0] as HTMLElement;
    element.click();
    eventBus.$emit('openQuickStartGuide', 'showGuide');
    */
    this.avatarPopoverVisible = false;
    this.openQsg({ flag: true });
  }
  private openHelp() {
    window.open(this.helpString, '_blank');
  }
}
